<template>
  <div v-if="!isFetchingAppIntegrations">
    <div v-if="isAIIntegrationEnabled" class="relative">
      <span
        v-tooltip.top="$t('INTEGRATION_SETTINGS.OPEN_AI.IMPROVE_TEXT_WITH_AI')"
        class="ai-generate-border flex"
        @click="openAIAssist"
      >
        <img :src="aiAssistIcon" alt="AI-generate" />
      </span>
      <woot-modal
        :show.sync="showAIAssistanceModal"
        :on-close="hideAIAssistanceModal"
      >
        <AIAssistanceModal
          :ai-option="aiOption"
          @apply-text="insertText"
          @close="hideAIAssistanceModal"
        />
      </woot-modal>
    </div>
    <div v-else-if="shouldShowAIAssistCTAButtonForAdmin" class="relative">
      <span
        v-tooltip.top="$t('INTEGRATION_SETTINGS.OPEN_AI.IMPROVE_TEXT_WITH_AI')"
        class="ai-generate-border flex"
        @click="openAICta"
      >
        <img :src="aiAssistIcon" alt="AI-generate" />
      </span>
      <woot-modal :show.sync="showAICtaModal" :on-close="hideAICtaModal">
        <chat-gpt-enable-modal :show="true" @close="hideAICtaModal" />
      </woot-modal>
    </div>
    <div v-else-if="!isAIIntegrationEnabled" class="relative">
      <AIAssistanceCTAButton
        @click="
          showAlert(
            $t(
              'INTEGRATION_SETTINGS.OPEN_AI.CTA_MODAL.AGENT_FORBIDDING_MESSAGE'
            )
          )
        "
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import AIAssistanceModal from './AIAssistanceModal.vue';
import adminMixin from 'dashboard/mixins/aiMixin';
import aiMixin from 'dashboard/mixins/isAdmin';
import { CMD_AI_ASSIST } from 'dashboard/routes/dashboard/commands/commandBarBusEvents';
import eventListenerMixins from 'shared/mixins/eventListenerMixins';
import { buildHotKeys } from 'shared/helpers/KeyboardHelpers';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import AIAssistanceCTAButton from './AIAssistanceCTAButton.vue';
import ChatGptEnableModal from './digital99Assistance/ChatGptEnableModal.vue';
import alertMixin from '../../../shared/mixins/alertMixin.js'; // d99d
import aiAssistSrc from 'dashboard/assets/images/ai-assist.svg';

export default {
  components: {
    AIAssistanceModal,
    ChatGptEnableModal,
    AIAssistanceCTAButton,
  },
  mixins: [
    aiMixin,
    eventListenerMixins,
    adminMixin,
    uiSettingsMixin,
    alertMixin,
  ],
  data: () => ({
    showAIAssistanceModal: false,
    showAICtaModal: false,
    aiOption: '',
    initialMessage: '',
  }),
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    isAICTAModalDismissed() {
      return this.uiSettings.is_open_ai_cta_modal_dismissed;
    },
    // Display a AI CTA button for admins if the AI integration has not been added yet and the AI assistance modal has not been dismissed.
    shouldShowAIAssistCTAButtonForAdmin() {
      return (
        this.isAdmin && !this.isAIIntegrationEnabled // &&
        //! this.isAICTAModalDismissed // d99d remarked out - show it always
      );
    },
    // Display a AI CTA button for agents and other admins who have not yet opened the AI assistance modal.
    shouldShowAIAssistCTAButton() {
      return this.isAIIntegrationEnabled; // && !this.isAICTAModalDismissed; // d99d remarked out - show it always
    },
    aiAssistIcon() {
      return aiAssistSrc;
    },
  },

  mounted() {
    bus.$on(CMD_AI_ASSIST, this.onAIAssist);
    this.initialMessage = this.draftMessage;
  },

  methods: {
    onKeyDownHandler(event) {
      const keyPattern = buildHotKeys(event);
      const shouldRevertTheContent =
        ['meta+z', 'ctrl+z'].includes(keyPattern) && !!this.initialMessage;
      if (shouldRevertTheContent) {
        this.$emit('replace-text', this.initialMessage);
        this.initialMessage = '';
      }
    },
    hideAIAssistanceModal() {
      this.recordAnalytics('DISMISS_AI_SUGGESTION', {
        aiOption: this.aiOption,
      });
      this.showAIAssistanceModal = false;
    },
    openAIAssist() {
      // Dismiss the CTA modal if it is not dismissed
      if (!this.isAICTAModalDismissed) {
        this.updateUISettings({
          is_open_ai_cta_modal_dismissed: true,
        });
      }
      this.initialMessage = this.draftMessage;
      const ninja = document.querySelector('ninja-keys');
      ninja.open({ parent: 'ai_assist' });
    },
    hideAICtaModal() {
      this.showAICtaModal = false;
    },
    openAICta() {
      this.showAICtaModal = true;
    },
    onAIAssist(option) {
      this.aiOption = option;
      this.showAIAssistanceModal = true;
    },
    insertText(message) {
      this.$emit('replace-text', message);
    },
  },
};
</script>
<style lang="scss" scoped>
.ai-generate-border {
  width: 32px;
  height: 32px;
  background: radial-gradient(circle at 100% 100%, #f0fdf4 0, #f0fdf4 3px, transparent 3px) 0% 0%/4px 4px no-repeat,
              radial-gradient(circle at 0 100%, #f0fdf4 0, #f0fdf4 3px, transparent 3px) 100% 0%/4px 4px no-repeat,
              radial-gradient(circle at 100% 0, #f0fdf4 0, #f0fdf4 3px, transparent 3px) 0% 100%/4px 4px no-repeat,
              radial-gradient(circle at 0 0, #f0fdf4 0, #f0fdf4 3px, transparent 3px) 100% 100%/4px 4px no-repeat,
              linear-gradient(#f0fdf4, #f0fdf4) 50% 50%/calc(100% - 2px) calc(100% - 8px) no-repeat,
              linear-gradient(#f0fdf4, #f0fdf4) 50% 50%/calc(100% - 8px) calc(100% - 2px) no-repeat,
              linear-gradient(90deg, #e3ef26 0%, #076653 46%, #0c342c 100%);
  border-radius: 4px;
  padding: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 19px;
    height: 19px;
  }
}
</style>
